import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
let PiSearchContent = class PiSearchContent extends Vue {
};
PiSearchContent = __decorate([
    Component
], PiSearchContent);
export default PiSearchContent;
